// Share program documents and aliases across client, dev, and built preview.
// Local HTTP handling mirrors the production program redirects/rewrites.
// Keep the old aliases ahead of the namespace fallback so they reach their final
// destinations directly, with query strings before any explicit lesson fragment.
export const AI30_PROGRAM = "/ai-30/program";

export const PROGRAM_REDIRECTS = {
  "/longhand-ai": AI30_PROGRAM,
  "/longhand-ai/index.html": AI30_PROGRAM,
  "/longhand-ai/atlas": `${AI30_PROGRAM}/atlas`,
  "/longhand-ai/prep": `${AI30_PROGRAM}/prep`,
  "/longhand-ai/ai-tune-up": `${AI30_PROGRAM}/ai-tune-up`,
  "/longhand-ai/roadmap": AI30_PROGRAM,
  "/longhand-ai/program": `${AI30_PROGRAM}/atlas`,
  "/longhand-ai/audit": `${AI30_PROGRAM}/ai-tune-up`,
  "/longhand-ai/audit.html": `${AI30_PROGRAM}/ai-tune-up`,
  "/longhand-ai/ai-tune-up.html": `${AI30_PROGRAM}/ai-tune-up`,
  "/longhand-ai-overview": `${AI30_PROGRAM}/overview`,
  "/longhand-ai/fundamentals": "/s2p-elevate-ai#ai-system-map",
  "/longhand-ai/swot": "/s2p-elevate-ai#ai-swot-library",
  [`${AI30_PROGRAM}/roadmap`]: AI30_PROGRAM,
  [`${AI30_PROGRAM}/index.html`]: AI30_PROGRAM,
  [`${AI30_PROGRAM}/audit`]: `${AI30_PROGRAM}/ai-tune-up`,
  [`${AI30_PROGRAM}/audit.html`]: `${AI30_PROGRAM}/ai-tune-up`,
  [`${AI30_PROGRAM}/ai-tune-up.html`]: `${AI30_PROGRAM}/ai-tune-up`,
  [`${AI30_PROGRAM}/fundamentals`]: "/s2p-elevate-ai#ai-system-map",
  [`${AI30_PROGRAM}/swot`]: "/s2p-elevate-ai#ai-swot-library",
};

export const PROGRAM_DOCUMENTS = {
  [AI30_PROGRAM]: `${AI30_PROGRAM}/index.html`,
  [`${AI30_PROGRAM}/ai-tune-up`]: `${AI30_PROGRAM}/ai-tune-up.html`,
};
const REACT_DOCUMENTS = new Set(["atlas", "prep", "overview"].map((slug) => `${AI30_PROGRAM}/${slug}`));

export function resolveAI30ProgramRequest(url, preview = false) {
  const queryStart = url.indexOf("?");
  const pathname = queryStart < 0 ? url : url.slice(0, queryStart);
  const search = queryStart < 0 ? "" : url.slice(queryStart);
  const cleanPath = pathname.replace(/\/+$/, "");
  const destination = PROGRAM_REDIRECTS[cleanPath]
    ?? (cleanPath.startsWith("/longhand-ai/") ? `${AI30_PROGRAM}${cleanPath.slice("/longhand-ai".length)}` : null);
  if (destination) {
    const [targetPath, hash] = destination.split("#");
    return { redirect: `${targetPath}${search}${hash ? `#${hash}` : ""}` };
  }
  if (PROGRAM_DOCUMENTS[cleanPath]) return { rewrite: `${PROGRAM_DOCUMENTS[cleanPath]}${search}` };
  if (preview && REACT_DOCUMENTS.has(cleanPath)) return { rewrite: `${cleanPath}/index.html${search}` };
  return null;
}
